import { axiosInstance } from 'src/boot/axios';
import i18n from 'src/i18n/index.js';

export function saveSeatedPatientTransport({ commit }, payload) {
  const formData = new FormData();
  formData.set('CurrentSelectedCustomerNumber', payload.selectedCustomerNumber);
  formData.set('RequestType', payload.requestValue.key);
  formData.set('SituationType', payload.treatmentType.key);

  if (payload.treatmentType.name === 'wheelchair') {
    formData.set('WheelChairSituation.MaxAmountWalking', payload.wheelchair?.distanceMeters);
    formData.set('WheelChairSituation.LongTermDependent', payload.wheelchair?.longDurationDependence?.key === 'yes');
    if (payload.wheelchair?.longDurationDependence?.key === 'no') {
      formData.set('WheelChairSituation.NumberOfMonths', payload.wheelchair?.shortDurationDependenceMonths);
    }
  } else if (payload.treatmentType.name === 'visually-impaired') {
    formData.set('VisuallyImpairedSituation.SmallerAs20Degrees', payload.visuallyImpaired.fieldOfVision?.key === 'yes');
    formData.set('VisuallyImpairedSituation.LeftEye', payload.visuallyImpaired.visionLeft);
    formData.set('VisuallyImpairedSituation.RightEye', payload.visuallyImpaired.visionRight);
  } else if (payload.treatmentType.name === 'hardship-clause') {
    formData.set('HardshipSituation.Indication', payload.hardshipClause.medicalIndication);
    formData.set(
      'HardshipSituation.MultipleInstances',
      payload.hardshipClause.multipleHealthcareInstitutes?.key === 'yes',
    );

    payload.hardshipClause.healthcareDestinations.forEach((element, index) => {
      formData.append(
        `HardshipSituation.CareInstances[${index}].Name`,
        payload.hardshipClause.healthcareDestinations[index].instanceName,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Address.PostalCode`,
        payload.hardshipClause.healthcareDestinations[index].postalCode,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Address.HouseNumber`,
        payload.hardshipClause.healthcareDestinations[index].houseNumber,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Address.City`,
        payload.hardshipClause.healthcareDestinations[index].city,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Address.Street`,
        payload.hardshipClause.healthcareDestinations[index].street,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Address.CountryCode`,
        payload.hardshipClause.healthcareDestinations[index].country.key,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Duration`,
        `${payload.hardshipClause.healthcareDestinations[index].treatmentDuration.amount}  ${payload.hardshipClause.healthcareDestinations[index].treatmentDuration.indication?.value}`,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].Distance`,
        payload.hardshipClause.healthcareDestinations[index].distance,
      );
      formData.append(
        `HardshipSituation.CareInstances[${index}].AmountTransportNeeded`,
        `${payload.hardshipClause.healthcareDestinations[index].averageTransportNeeded} ${
          payload.hardshipClause.healthcareDestinations[index].treatmentDuration.indication?.key === 2
            ? i18n.global.t('request-seated-patient-transport.flows.hardship-clause.inputs.time.each-month')
            : i18n.global.t('request-seated-patient-transport.flows.hardship-clause.inputs.time.each-week')
        }`,
      );
    });
  } else {
    formData.set('AllOtherSituation.Name', payload.otherQuestions.instanceName);
    formData.set('AllOtherSituation.CareInstance.PostalCode', payload.otherQuestions.postalCode);
    formData.set('AllOtherSituation.CareInstance.HouseNumber', payload.otherQuestions.houseNumber);
    formData.set('AllOtherSituation.CareInstance.City', payload.otherQuestions.city);
    formData.set('AllOtherSituation.CareInstance.Street', payload.otherQuestions.street);
    formData.set('AllOtherSituation.CareInstance.CountryCode', 'NL');
  }
  formData.set('StartDate', payload.expectedTreatmentPeriod.fromDate);
  formData.set('EndDate', payload.expectedTreatmentPeriod.toDate);
  formData.set('CanTravelOwn', payload.travelPossibilities.ownTransport?.key === 'yes');
  if (payload.travelPossibilities.ownTransport?.key === 'no') {
    formData.set('CanTravelPublic', payload.travelPossibilities.public?.key === 'yes');
    if (payload.travelPossibilities.public?.key === 'no') {
      formData.set('CanOnlyTravelCab', payload.travelPossibilities.taxi?.key === 'yes');
      formData.set('OnlyTravelCabExplanation', payload.travelPossibilities.taxiExplanation);
    }
    formData.set('NeedsEscort', payload.travelPossibilities.assistance?.key === 'yes');
  }
  if (payload.details) {
    formData.set('AdditionalInformation', payload.details);
  }

  payload.documents.forEach((element) => {
    formData.append('Files', element.file);
  });

  commit('setIsSavingSeatedPatientTransport', true);
  return axiosInstance.post('SeatedPatientTransport', formData).finally(() => {
    commit('setIsSavingSeatedPatientTransport', false);
  });
}
